import React, {useEffect,useState} from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from "axios";
const EditPatients = () => {
 // const { id } = useParams();
 useEffect(() => {
         const scriptUrls = [
           'assets/js/jquery.min.js',
           'assets/js/bootstrap.bundle.min.js',
           'assets/js/moment.min.js',
           'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
           'assets/vendor/overlay-scroll/custom-scrollbar.js',
           'assets/vendor/daterange/daterange.js',
           'assets/vendor/daterange/custom-daterange.js',
           'assets/vendor/jquery-ui/jquery-ui.min.js',
           'assets/vendor/jquery-ui/custom.js',
           //'assets/vendor/apex/apexcharts.min.js',
           //'assets/vendor/apex/custom/home/patients.js',
           //'assets/vendor/apex/custom/home/department-income.js',
           //'assets/vendor/apex/custom/home/income.js',
           //'assets/vendor/apex/custom/home/appointments-overview.js',
           //'assets/vendor/apex/custom/home/sparklines.js',
           'assets/vendor/datatables/dataTables.min.js',
           'assets/vendor/datatables/dataTables.bootstrap.min.js',
           'assets/vendor/datatables/custom/custom-datatables.js',
           'assets/js/custom.js'
         ];
     
         let isCancelled = false;
     
         // Load scripts sequentially
         const loadScriptsSequentially = async () => {
           for (const url of scriptUrls) {
             if (isCancelled) break;
     
             await new Promise((resolve, reject) => {
               const script = document.createElement('script');
               script.src = url;
               script.onload = resolve;
               script.onerror = reject;
               document.body.appendChild(script);
             });
           }
         };
     
         loadScriptsSequentially();
     
         return () => {
           isCancelled = true;
           // Optionally remove scripts if needed
         };
       }, []);
  const navigate = useNavigate(); // For navigation
  const location = useLocation();
  const uata = location.state?.uata;
  const [department, setDepartment] = useState([]);
  const [depName, setDepName] = useState('');
  const [depEmail, setDepEmail] = useState('');
  const [depHead, setDepHead] = useState('');
  const [depPhone, setDepPhone] =useState('');
  const [noRooms, setNoRooms] = useState('');
  const [noBeds, setNoBeds] =useState('');
  const [status, setStatus] = useState('');
  const [message, setMessage] = useState('');
  useEffect(() =>{
    const REST_API_BASE_URL = `http://localhost:8080/api/listBooks/${uata}`;
    const departmentById =() => axios.get(REST_API_BASE_URL);
    departmentById().then((response) => {
      const departmentData = response.data;
      setDepartment(departmentData);
      setDepName(departmentData.depName);
      setDepEmail(departmentData.depEmail);
      setDepHead(departmentData.setDepHead);
      setDepPhone(departmentData.depPhone);
      setNoRooms(departmentData.noRooms);
      setNoBeds(departmentData.noBeds);
      setStatus(departmentData.status);
      setMessage(departmentData.message);
        
    }).catch(error =>{
        window.alert(error+" "+uata);
        
    })
} , [])
  const handleUpdate = (e) => {
    // Prevent default form submission
    e.preventDefault();

    // Show confirmation dialog
    const confirmUpdate = window.confirm(
      `Are you sure you want to update item with ID: ${uata}?`
    );

    if (confirmUpdate) {
      // If confirmed, perform the update action
      
      const formData = new FormData();
      formData.append("jsonData" , JSON.stringify({
        
        "dep_name":depName,
        "dep_email":depEmail,
        "dep_head":depHead,
        "dep_phone":depPhone,
        "no_rooms":noRooms,
        "no_beds":noBeds,
        "status":status,
        "message":message
        
      }));
      
      console.log();
      const REST_API_BASE_URL = `http://localhost:8080/api/insBookById/${uata}`;
      const updateWithIds=(formData) => axios.put(REST_API_BASE_URL,formData);
      updateWithIds(formData)
        .then((response) => {
          console.log(response.data);
          window.alert(`Successfully updation done with ${uata}`);
          
          // After deletion, redirect to another page (e.g., home or item list)
          navigate("/booklist"); // Navigates back to the homepage or another route
        })
        .catch((error) => {
          window.alert("Error occurred while updating the item.");
          console.error(error);
        });
    } else {
      // If cancelled, do nothing (or show a cancellation message)
      window.alert("Updation cancelled");
      navigate("/departments-list");
    }
  };

  return (
    <div>
  {/* App hero header starts */}
  <div className="app-hero-header d-flex align-items-center">
    {/* Breadcrumb starts */}
    <ol className="breadcrumb">
      <li className="breadcrumb-item">
        <a href="index-2.html">
          <i className="ri-home-3-line" />
        </a>
      </li>
      <li className="breadcrumb-item text-primary" aria-current="page">
        Edit Patient Details
      </li>
    </ol>
    {/* Breadcrumb ends */}
    {/* Sales stats starts */}
    <div className="ms-auto d-lg-flex d-none flex-row">
      <div className="input-group">
        <span className="input-group-text bg-primary-lighten">
          <i className="ri-calendar-2-line text-primary" />
        </span>
        <input type="text" id="abc" className="form-control custom-daterange" />
      </div>
    </div>
    {/* Sales stats ends */}
  </div>
  {/* App Hero header ends */}
  {/* App body starts */}
  <div className="app-body">
    {/* Row starts */}
    <div className="row gx-4">
      <div className="col-sm-12">
        <div className="card">
          <div className="card-header">
            <h5 className="card-title">Edit Patient Details</h5>
          </div>
          <div className="card-body">
            {/* Row starts */}
            <div className="row gx-4">
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a1">First Name</label>
                  <input type="text" className="form-control" id="a1" defaultValue="Carole" />
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a2">Last Name</label>
                  <input type="text" className="form-control" id="a2" defaultValue="Dodson" />
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a3">Age</label>
                  <select className="form-select" id="a3">
                    <option value={0}>68</option>
                    <option value={1}>1</option>
                    <option value={2}>2</option>
                    <option value={3}>3</option>
                    <option value={4}>4</option>
                    <option value={5}>5</option>
                    <option value={6}>6</option>
                    <option value={7}>7</option>
                    <option value={8}>8</option>
                  </select>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="selectGender1">Gender</label>
                  <div className="m-0">
                    <div className="form-check form-check-inline">
                      <input className="form-check-input" type="radio" name="selectGenderOptions" id="selectGender1" defaultValue="male" defaultChecked />
                      <label className="form-check-label" htmlFor="selectGender1">Male</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input className="form-check-input" type="radio" name="selectGenderOptions" id="selectGender2" defaultValue="female" />
                      <label className="form-check-label" htmlFor="selectGender2">Female</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a4">Create ID</label>
                  <input type="text" className="form-control" id="a4" defaultValue={89890} />
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a5">Email ID</label>
                  <input type="email" className="form-control" id="a5" defaultValue="test@testing.com" />
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a6">Mobile Number</label>
                  <input type="text" className="form-control" id="a6" defaultValue={""} />
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a7">Marital Status</label>
                  <select className="form-select" id="a7">
                    <option value={0}>Married</option>
                    <option value={1}>Married</option>
                    <option value={2}>Un Married</option>
                  </select>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a8">Occupation</label>
                  <select className="form-select" id="a8">
                    <option value={0}>Engineer</option>
                    <option value={1}>Teacher</option>
                    <option value={2}>Engineer</option>
                    <option value={3}>Business</option>
                    <option value={4}>Bank</option>
                    <option value={5}>Army</option>
                  </select>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a9">Blood Group</label>
                  <select className="form-select" id="a9">
                    <option value={0}>A+</option>
                    <option value={1}>A+</option>
                    <option value={2}>A-</option>
                    <option value={3}>B+</option>
                    <option value={4}>B-</option>
                    <option value={5}>O+</option>
                    <option value={6}>O-</option>
                    <option value={7}>AB+</option>
                    <option value={8}>AB-</option>
                  </select>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a10">Blood Presure</label>
                  <input type="text" className="form-control" id="a10" defaultValue={160} />
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a11">Sugar</label>
                  <input type="text" className="form-control" id="a11" defaultValue={130} />
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a12">Address</label>
                  <textarea className="form-control" id="a12" placeholder="Enter message" rows={2} defaultValue={"89 Markus Turnpike"} />
                </div>
              </div>
             
              <div className="col-sm-12">
                <div className="bg-light rounded-3 p-3 mb-3">
                  <div className="table-outer">
                    <div className="table-responsive">
                      <table className="table align-middle truncate m-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>File</th>
                            <th>Reports Link</th>
                            <th>Date</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>
                              <div className="icon-box md bg-primary rounded-2">
                                <i className="ri-file-excel-2-line" />
                              </div>
                            </td>
                            <td><a href="#!" className="link-primary text-truncate">Reports 1 clinical
                                documentation</a></td>
                            <td>May-24, 2024</td>
                            <td>
                              <div className="d-inline-flex gap-1">
                                <button className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow">
                                  <i className="ri-delete-bin-line" />
                                </button>
                                <button className="btn btn-outline-info btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Download Report">
                                  <i className="ri-file-download-line" />
                                </button>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              <div className="icon-box md bg-primary rounded-2">
                                <i className="ri-file-excel-2-line" />
                              </div>
                            </td>
                            <td>
                              <a href="#!" className="link-primary text-truncate">Reports 2 random files
                                documentation</a>
                            </td>
                            <td>Feb-20, 2024</td>
                            <td>
                              <div className="d-inline-flex gap-1">
                                <button className="btn btn-outline-danger btn-sm" data-bs-toggle="modal" data-bs-target="#delRow">
                                  <i className="ri-delete-bin-line" />
                                </button>
                                <button className="btn btn-outline-info btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Download Report">
                                  <i className="ri-file-download-line" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12">
                <div id="dropzone" className="dropzone-dark mb-3">
                  <form action="https://bootstrapget.com/upload" className="dropzone needsclick dz-clickable" id="demo-upload">
                    <div className="dz-message needsclick">
                      <button type="button" className="dz-button">
                        Click here to upload or Drop your reports here.</button>
                      <h5>Upload your health reports.</h5>
                    </div>
                  </form>
                </div>
              </div>
              <div className="col-sm-12">
                <div className="d-flex gap-2 justify-content-end">
                  <a href="patients-list.html" type="button" className="btn btn-outline-secondary">
                    Cancel
                  </a>
                  <a href="patients-lists" type="button" className="btn btn-primary" onClick={handleUpdate}>
                    Updte Patient Details
                  </a>
                </div>
              </div>
            </div>
            {/* Row ends */}
          </div>
        </div>
      </div>
    </div>
    {/* Row ends */}
    {/* Modal Delete Row */}
    <div className="modal fade" id="delRow" tabIndex={-1} aria-labelledby="delRowLabel" aria-hidden="true">
      <div className="modal-dialog modal-sm">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="delRowLabel">
              Are you sure?
            </h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
          </div>
          <div className="modal-body">
            Are you sure you want to delete this report?
          </div>
          <div className="modal-footer">
            <div className="d-flex justify-content-end gap-2">
              <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>
              <button className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close">Yes</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* App body ends */}
</div>


  );
};

export default EditPatients;

